import { render, staticRenderFns } from "./layer-assets-details-inventory.vue?vue&type=template&id=453a3ec8&scoped=true&"
import script from "./layer-assets-details-inventory.vue?vue&type=script&lang=js&"
export * from "./layer-assets-details-inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453a3ec8",
  null
  
)

export default component.exports